import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { SupplierVS } from 'shared/utils/validation/AuthValidation';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { GetAllPOQuery } from 'shared/services/po_service/POService';

export default function SaleOrderSuplierModal({ show, handleClose, SubmmitPo, setSupplierVal, isEdit = false }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const { data: PoList } = GetAllPOQuery();

    const [supplierSuggestions, setSupplierSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const suggestionRef = useRef(null);

    const initialValues = {
        supplier: '',
        address: '',
        phone: '',
        refFeild: '',
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: SupplierVS,
        onSubmit: (value) => {
            const payload = {
                shipping: {
                    customerName: value.supplier,
                    address: value.address,
                    phone: value.phone,
                    reference: value.refFeild
                }
            };

            SubmmitPo(payload);
        }
    });

    const { handleSubmit, values, touched, errors, setFieldValue } = formik;

    const handleSupplierChange = (e) => {
        const inputValue = e.target.value;
        setFieldValue('supplier', inputValue);

        if (PoList && PoList.length > 0 && inputValue.trim() !== '') {
            const matchedSuppliers = PoList
                .filter(po => po.supplier?.name?.toLowerCase().includes(inputValue.toLowerCase()))
                .map(po => ({
                    name: po.supplier?.name,
                    address: po.supplier?.address,
                    phone: po.supplier?.phone
                }));

            const uniqueSuppliers = matchedSuppliers.filter(
                (obj, index, self) =>
                    index === self.findIndex((o) => o.name === obj.name)
            );

            setSupplierSuggestions(uniqueSuppliers);
            setShowSuggestions(true);
        } else {
            setSupplierSuggestions([]);
            setShowSuggestions(false);
        }
    };

    const handleSelectSuggestion = (supplier) => {
        setFieldValue('supplier', supplier.name);
        setFieldValue('address', supplier.address || '');
        setFieldValue('phone', supplier.phone || '');
        setShowSuggestions(false);
    };

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={'Add Shipping Address'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    <div className={styles.flexex}>
                        <div className="w-100">
                            <div className={styles.SuggestionWrapper} ref={suggestionRef}>
                                <CustomInput
                                    label={'Customer Name'}
                                    placeholder={'e.g. John'}
                                    value={values.supplier}
                                    onChange={handleSupplierChange}
                                    autoComplete="off"
                                    CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                                    CustomLabelStyle={styles.CustomLabelStyle}
                                    InputContainerStyle={styles.InputContainerStyle}
                                    error={errors.supplier && touched.supplier ? errors.supplier : ''}
                                />
                                {showSuggestions && supplierSuggestions.length > 0 && (
                                    <div className={styles.SuggestionsList}>
                                        {supplierSuggestions.map((supplier, index) => (
                                            <div
                                                key={index}
                                                className={styles.SuggestionItem}
                                                onClick={() => handleSelectSuggestion(supplier)}
                                            >
                                                {supplier.name}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <CustomInput
                                label={'Shipping Address'}
                                placeholder={'e.g. Address'}
                                value={values.address}
                                onChange={(e) => setFieldValue('address', e.target.value)}
                                CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                                CustomLabelStyle={styles.CustomLabelStyle}
                                InputContainerStyle={styles.InputContainerStyle}
                                error={errors.address && touched.address ? errors.address : ''}
                            />

                            <CustomInput
                                label={'Phone Number'}
                                placeholder={'e.g. 1234567890'}
                                value={values.phone}
                                type="number"
                                onChange={(e) => setFieldValue('phone', e.target.value)}
                                CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                                CustomLabelStyle={styles.CustomLabelStyle}
                                InputContainerStyle={styles.InputContainerStyle}
                                error={errors.phone && touched.phone ? errors.phone : ''}
                            />

                            <CustomInput
                                label={'Reference Number'}
                                placeholder={'e.g. Reference Number'}
                                value={values.refFeild}
                                onChange={(e) => setFieldValue('refFeild', e.target.value)}
                                CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                                CustomLabelStyle={styles.CustomLabelStyle}
                                InputContainerStyle={styles.InputContainerStyle}
                                error={errors.refFeild && touched.refFeild ? errors.refFeild : ''}
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton text={'Create SO'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
